function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from '@bydesign-ui/utils';
import { popperCore } from './PopperCore';
export var Popper = function () {
  function Popper() {
    _classCallCheck(this, Popper);

    this.id = guid();
    this.triggerMap = {};
    this.popoverMap = {};
    this.showIds = [];
    this.disposed = false;
    popperCore.addPopper(this);
  }

  _createClass(Popper, [{
    key: "dispose",
    value: function dispose() {
      var _this = this;

      Object.keys(this.triggerMap).forEach(function (id) {
        _this.triggerMap[id] && _this.triggerMap[id].dispose();
      });
      Object.keys(this.popoverMap).forEach(function (id) {
        _this.popoverMap[id] && _this.popoverMap[id].dispose();
      });
      this.triggerMap = {};
      this.popoverMap = {};
      this.showIds = [];
      this.disposed = true;
      popperCore.removePopper(this);
    }
  }, {
    key: "registerTrigger",
    value: function registerTrigger(trigger) {
      var triggerId = trigger.getId();

      if (this.triggerMap[triggerId]) {
        console.error("id=".concat(triggerId, " trigger component has been registered"));
        return;
      }

      this.triggerMap[triggerId] = trigger;
    }
  }, {
    key: "unregisterTrigger",
    value: function unregisterTrigger(trigger) {
      var _this2 = this;

      var triggerId = trigger.getId();

      if (!this.triggerMap[triggerId]) {
        console.error("id=".concat(triggerId, " trigger component unregister fail"));
        return;
      }

      Object.keys(this.popoverMap).forEach(function (key) {
        var popover = _this2.getPopover(key);

        if (!popover) {
          return;
        }

        var hasHide = false;

        if (popover.getRefTriggerId() === triggerId) {
          hasHide = true;
        }

        if (popover.getLastTrigger() === triggerId) {
          popover.setLastTrigger('');
          hasHide = true;
        }

        hasHide && popover.isShow() && popover.hidePopover();
      });
      delete this.triggerMap[triggerId];
    }
  }, {
    key: "registerPopover",
    value: function registerPopover(popover) {
      var popoverId = popover.getId();

      if (this.popoverMap[popoverId]) {
        console.error("id=".concat(popoverId, " popover component has been registered"));
        return;
      }

      this.popoverMap[popoverId] = popover;
    }
  }, {
    key: "unregisterPopover",
    value: function unregisterPopover(popover) {
      var popoverId = popover.getId();

      if (!this.popoverMap[popoverId]) {
        console.error("id=".concat(popoverId, " popover component unregister fail"));
        return;
      }

      delete this.popoverMap[popoverId];
      var idx = this.showIds.indexOf(popoverId);

      if (idx >= 0) {
        this.showIds.splice(idx, 1);
      }
    }
  }, {
    key: "getTrigger",
    value: function getTrigger(triggerId) {
      return this.triggerMap[triggerId];
    }
  }, {
    key: "getPopover",
    value: function getPopover(popoverId) {
      return this.popoverMap[popoverId];
    }
  }, {
    key: "getShowIds",
    value: function getShowIds() {
      return this.showIds;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "showPopper",
    value: function showPopper(triggerId) {
      var _this3 = this;

      var trigger = this.triggerMap[triggerId];

      if (this.disposed) {
        return;
      }

      if (!trigger) {
        console.error("id=".concat(triggerId, " trigger component does not exist"));
        return;
      }

      var triggerIdPath = trigger.getTriggerIdPath();
      var showIds = [];
      Object.keys(this.popoverMap).forEach(function (popoverId) {
        var popover = _this3.popoverMap[popoverId];
        var triggerIds = popover.getTriggerIds();
        var unionPopoverIds = popover.getUnionPopoverIds();

        if (showIds.indexOf(popoverId) >= 0) {
          return;
        }

        triggerIds.forEach(function (tid) {
          if (triggerIdPath.indexOf(tid) < 0) {
            return;
          }

          showIds.push(popoverId);
          popover.setLastTrigger(triggerId);
          unionPopoverIds.forEach(function (pid) {
            if (showIds.indexOf(pid) < 0) {
              showIds.push(pid);
            }
          });
        });
      });
      showIds.forEach(function (id) {
        _this3.popoverMap[id].showPopover();
      });
    }
  }, {
    key: "hidePopper",
    value: function hidePopper(triggerId) {
      var _this4 = this;

      var trigger = this.triggerMap[triggerId];

      if (!trigger) {
        return;
      }

      var triggerIdPath = trigger.getTriggerIdPath();
      var needHideIds = [];
      Object.keys(this.popoverMap).forEach(function (popoverId) {
        var popover = _this4.popoverMap[popoverId];
        var triggerIds = popover.getTriggerIds();
        triggerIds.forEach(function (tid) {
          if (triggerIdPath.indexOf(tid) >= 0 && popover.getLastTrigger() === triggerId && needHideIds.indexOf(popoverId) < 0) {
            needHideIds.push(popoverId);
          }
        });
      });
      needHideIds.forEach(function (id) {
        return _this4.getPopover(id).hidePopover();
      });
    }
  }, {
    key: "updateRefRect",
    value: function updateRefRect(triggerId) {
      var _this5 = this;

      this.showIds.forEach(function (id) {
        var popover = _this5.popoverMap[id];
        var refType = popover.getRefType();
        var refId = popover.getRefId();

        if (refType === 'trigger' && refId === triggerId || refType === 'lastTrigger' && popover.getLastTrigger() === triggerId) {
          popover.updateRefRect();
        }
      });
    }
  }, {
    key: "updatePopoverRect",
    value: function updatePopoverRect(popoverId) {
      var _this6 = this;

      this.showIds.forEach(function (id) {
        var popover = _this6.popoverMap[id];
        var refType = popover.getRefType();
        var refId = popover.getRefId();

        if (refType === 'popover' && refId === popoverId) {
          popover.updateRefRect();
        }
      });
    }
  }, {
    key: "setActiveShow",
    value: function setActiveShow(triggerId) {
      var trigger = this.triggerMap[triggerId];

      if (trigger == null) {
        return;
      }

      trigger.setActiveShow(true);
    }
  }, {
    key: "cancelActiveShow",
    value: function cancelActiveShow(triggerId) {
      var trigger = this.triggerMap[triggerId];

      if (trigger == null) {
        return;
      }

      trigger.setActiveShow(false);
    }
  }, {
    key: "isActiveShow",
    value: function isActiveShow(triggerId) {
      var trigger = this.triggerMap[triggerId];

      if (trigger == null) {
        return false;
      }

      return trigger.isActiveShow();
    }
  }, {
    key: "setPopoverShow",
    value: function setPopoverShow(popoverId, show) {
      if (!this.popoverMap[popoverId]) {
        return;
      }

      var idx = this.showIds.indexOf(popoverId);
      var lastTrigger = this.getTrigger(this.popoverMap[popoverId].getLastTrigger()) || null;

      if (show && idx < 0) {
        this.showIds.push(popoverId);
      } else if (!show && idx >= 0) {
        this.showIds.splice(idx, 1);
        lastTrigger && lastTrigger.setActiveShow(false);
      }
    }
  }, {
    key: "syncSingleGroup",
    value: function syncSingleGroup(groupId, popoverId) {
      var _this7 = this;

      Object.keys(this.popoverMap).forEach(function (key) {
        var popover = _this7.popoverMap[key];

        if (popover.getGroupId() !== groupId || popover.getId() === popoverId) {
          return;
        }

        popover.hidePopover();
      });
    }
  }, {
    key: "hideAllPopover",
    value: function hideAllPopover(triggerType) {
      var _this8 = this;

      var excludeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var needHideIds = [];
      this.showIds.forEach(function (popoverId) {
        var popover = _this8.popoverMap[popoverId];

        if (!popover || excludeIds.indexOf(popoverId) >= 0) {
          return;
        }

        if (!triggerType && needHideIds.indexOf(popoverId) < 0) {
          needHideIds.push(popoverId);
        }

        var triggerIds = popover.getTriggerIds();

        if (triggerIds.some(function (id) {
          return _this8.getTrigger(id).getTriggerType() === triggerType;
        }) && needHideIds.indexOf(popoverId) < 0) {
          needHideIds.push(popoverId);
        }
      });
      needHideIds.forEach(function (id) {
        return _this8.getPopover(id).hidePopover();
      });
    }
  }, {
    key: "isTriggerFocus",
    value: function isTriggerFocus(triggerId) {
      var _this9 = this;

      var ids = this.getShowIds();
      return ids.some(function (id) {
        var popover = _this9.getPopover(id);

        var refId = popover.getRefTriggerId();

        if (!refId && _this9.triggerMap[refId]) {
          return;
        }

        var trigger = _this9.getTrigger(refId);

        if (!trigger) {
          return false;
        }

        if (trigger.isGroup()) {
          return triggerId === trigger.getActiveTrigger();
        }

        return triggerId === refId;
      });
    }
  }, {
    key: "isPopoverShow",
    value: function isPopoverShow(id) {
      return this.showIds.indexOf(id) >= 0;
    }
  }]);

  return Popper;
}();